export default [
  // Primary District is a fixtures district and includes predicatable data types, used in both testing and dev envs
  // Secondary District is factory generated data, used in dev environment strictly
  {
    id: '10000',
    name: 'Colorado Fictional District',
    type: 'District',
    listed: true,
    district: null,
    outgoingSubscriptionAllotments: 15,
    remainingLicenseCount: 10,
    maxLicenseCount: 90,
  },
  {
    id: '10002',
    name: 'Greendale Community College',
    type: 'School',
    listed: true,
    district: '10000',
    incomingSubscriptionAllotments: 10,
    remainingLicenseCount: 10,
    maxLicenseCount: 42,
    districtLicencesAvailable: 4,
    syncDetailsId: '1',
  },
  {
    id: '10003',
    name: 'City College',
    type: 'School',
    listed: true,
    district: '10000',
    incomingSubscriptionAllotments: 0,
    remainingLicenseCount: 172,
    maxLicenseCount: 236,
    districtLicencesAvailable: 50,
    syncDetailsId: '2',
    settingsId: '10003',
  },
  {
    id: '10010',
    name: 'Secondary District',
    type: 'District',
    listed: true,
    district: null,
    outgoingSubscriptionAllotments: 5,
    remainingLicenseCount: 12,
    maxLicenseCount: 42,
  },
  {
    id: '10011',
    name: 'Hogwarts School of Witchcraft and Wizardry',
    type: 'School',
    district: '10010',
    incomingSubscriptionAllotments: 5,
    remainingLicenseCount: 5,
    maxLicenseCount: 24,
    districtLicencesAvailable: 4,
    syncDetailsId: '7',
  },
  {
    id: '11000',
    name: 'Clone High',
    type: 'School',
    listed: true,
    district: null,
    remainingLicenseCountInClosure: 0,
    outgoingSubscriptionAllotments: 0,
    remainingLicenseCount: 0,
    maxLicenseCount: 0,
  },
  {
    id: '12000',
    name: 'Rocky Mountain School Trust',
    type: 'District',
    listed: true,
    district: null,
    outgoingSubscriptionAllotments: 15,
    remainingLicenseCount: 20,
    maxLicenseCount: 35,
    districtLicensesAvailable: 35,
  },
  {
    id: '12001',
    name: 'Athabasca High School',
    type: 'School',
    listed: true,
    district: '12000',
    remainingLicenseCount: 20,
    maxLicenseCount: 35,
    districtLicensesAvailable: 35,
    syncDetailsId: '3',
  },
  {
    id: '12002',
    name: 'Brazeau Elementary School',
    type: 'School',
    listed: true,
    district: '12000',
    incomingSubscriptionAllotments: 15,
    remainingLicenseCount: 7,
    maxLicenseCount: 15,
    syncDetailsId: '4',
  },
  {
    id: '12003',
    name: 'Doyle Elementary School',
    type: 'School',
    listed: true,
    district: '12000',
    incomingSubscriptionAllotments: 20,
    remainingLicenseCount: 10,
    maxLicenseCount: 15,
    syncDetailsId: '5',
  },
  {
    id: '12005',
    name: 'Alaska Elementary School',
    type: 'School',
    listed: true,
    district: '10010',
    syncDetailsId: '6',
  },
  {
    id: '12006',
    name: 'Madison Middle School',
    type: 'School',
    listed: true,
    district: '10010',
  },
];
